export const REQUEST_SUCCESS = "REQUEST_SUCCESS";
export const REQUEST_ERROR = "REQUEST_ERROR";
export const REQUESTING = "REQUESTING";
export const DELETE = "DELETE";
export const POST = "POST";
export const PUT = "PUT";
export const GET = "GET";
